var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 395.61 937.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-395);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137, .cls-138, .cls-139, .cls-140, .cls-141, .cls-142, .cls-143, .cls-144, .cls-145, .cls-146, .cls-147, .cls-148, .cls-149, .cls-150, .cls-151, .cls-152, .cls-153, .cls-154, .cls-155, .cls-156, .cls-157, .cls-158, .cls-159, .cls-160, .cls-161, .cls-162, .cls-163, .cls-164, .cls-165, .cls-166, .cls-167, .cls-168, .cls-169, .cls-170, .cls-171, .cls-172, .cls-173, .cls-174, .cls-175, .cls-176, .cls-177, .cls-178, .cls-179, .cls-180, .cls-181, .cls-182, .cls-183, .cls-184, .cls-185, .cls-186, .cls-187, .cls-188, .cls-189, .cls-190, .cls-191, .cls-192, .cls-193, .cls-194, .cls-195, .cls-196, .cls-197, .cls-198, .cls-199, .cls-200, .cls-201, .cls-202, .cls-203, .cls-204, .cls-205, .cls-206, .cls-207, .cls-208, .cls-209, .cls-210, .cls-211, .cls-212, .cls-213, .cls-214, .cls-215, .cls-216, .cls-217, .cls-218, .cls-219, .cls-220, .cls-221, .cls-222, .cls-223, .cls-224, .cls-225, .cls-226, .cls-227, .cls-228, .cls-229, .cls-230, .cls-231, .cls-232, .cls-233, .cls-234, .cls-235, .cls-236, .cls-237, .cls-238, .cls-239, .cls-240, .cls-241, .cls-242, .cls-243, .cls-244, .cls-245, .cls-246, .cls-247, .cls-248, .cls-249, .cls-250, .cls-251, .cls-252, .cls-253, .cls-254, .cls-255, .cls-256, .cls-257, .cls-258, .cls-259, .cls-260, .cls-261, .cls-262, .cls-263, .cls-264, .cls-265, .cls-266, .cls-267, .cls-268, .cls-269, .cls-270, .cls-271, .cls-272, .cls-273, .cls-274, .cls-275, .cls-276, .cls-277, .cls-278, .cls-279, .cls-280, .cls-281, .cls-282, .cls-283, .cls-284, .cls-285, .cls-286, .cls-287, .cls-288, .cls-289, .cls-290, .cls-291, .cls-292, .cls-293, .cls-294, .cls-295, .cls-296, .cls-297, .cls-298, .cls-299, .cls-300, .cls-301, .cls-302, .cls-303, .cls-304, .cls-305, .cls-306, .cls-307, .cls-308, .cls-309, .cls-310, .cls-311, .cls-312, .cls-313, .cls-314, .cls-315, .cls-316, .cls-317, .cls-318, .cls-319, .cls-320, .cls-321, .cls-322, .cls-323, .cls-324, .cls-325, .cls-326, .cls-327, .cls-328, .cls-329, .cls-330, .cls-331, .cls-332, .cls-333, .cls-334, .cls-335, .cls-336, .cls-337, .cls-338, .cls-339, .cls-340, .cls-341, .cls-342, .cls-343, .cls-344, .cls-345, .cls-346, .cls-347, .cls-348, .cls-349, .cls-350, .cls-351, .cls-352, .cls-353, .cls-354, .cls-355, .cls-356, .cls-357, .cls-358, .cls-359, .cls-360, .cls-361, .cls-362, .cls-363, .cls-364, .cls-365, .cls-366, .cls-367, .cls-368, .cls-369, .cls-370, .cls-371, .cls-372, .cls-373, .cls-374, .cls-375, .cls-376, .cls-377, .cls-378, .cls-379, .cls-380, .cls-381, .cls-382, .cls-383, .cls-384, .cls-385, .cls-386, .cls-387, .cls-388, .cls-389, .cls-390, .cls-391, .cls-392, .cls-393, .cls-394, .cls-395, .cls-396, .cls-397 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-392);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-393);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-390);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-391);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-396);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-397);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-348);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-347);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-346);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-349);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-373);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-372);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-370);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-371);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-394);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-366);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-379);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-374);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-352);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-353);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-355);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-375);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-350);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-360);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-365);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-363);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-362);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-361);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-367);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-377);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-376);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-358);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-356);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-359);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-357);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-344);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-351);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-378);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-368);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-345);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-343);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-342);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-364);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-340);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-341);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-369);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-354);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-179);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-177);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-176);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-178);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-120);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-125);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-124);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-126);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-188);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-180);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-184);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-185);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-186);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-187);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-181);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-182);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-183);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-138);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-139);\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient-134);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-131);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-136);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-132);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-135);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-130);\n      }\n\n      .cls-74 {\n        fill: url(#linear-gradient-133);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-137);\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-197);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-196);\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-195);\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-194);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-189);\n      }\n\n      .cls-81 {\n        fill: url(#linear-gradient-190);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-199);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-100);\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-101);\n      }\n\n      .cls-85 {\n        fill: url(#linear-gradient-192);\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-191);\n      }\n\n      .cls-87 {\n        fill: url(#linear-gradient-193);\n      }\n\n      .cls-88 {\n        fill: url(#linear-gradient-198);\n      }\n\n      .cls-89 {\n        fill: url(#linear-gradient-123);\n      }\n\n      .cls-90 {\n        fill: url(#linear-gradient-129);\n      }\n\n      .cls-91 {\n        fill: url(#linear-gradient-121);\n      }\n\n      .cls-92 {\n        fill: url(#linear-gradient-122);\n      }\n\n      .cls-93 {\n        fill: url(#linear-gradient-109);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-108);\n      }\n\n      .cls-95 {\n        fill: url(#linear-gradient-106);\n      }\n\n      .cls-96 {\n        fill: url(#linear-gradient-107);\n      }\n\n      .cls-97 {\n        fill: url(#linear-gradient-102);\n      }\n\n      .cls-98 {\n        fill: url(#linear-gradient-104);\n      }\n\n      .cls-99 {\n        fill: url(#linear-gradient-103);\n      }\n\n      .cls-100 {\n        fill: url(#linear-gradient-105);\n      }\n\n      .cls-101 {\n        fill: url(#linear-gradient-117);\n      }\n\n      .cls-102 {\n        fill: url(#linear-gradient-118);\n      }\n\n      .cls-103 {\n        fill: url(#linear-gradient-111);\n      }\n\n      .cls-104 {\n        fill: url(#linear-gradient-112);\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-127);\n      }\n\n      .cls-106 {\n        fill: url(#linear-gradient-128);\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-110);\n      }\n\n      .cls-108 {\n        fill: url(#linear-gradient-113);\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-114);\n      }\n\n      .cls-110 {\n        fill: url(#linear-gradient-115);\n      }\n\n      .cls-111 {\n        fill: url(#linear-gradient-116);\n      }\n\n      .cls-112 {\n        fill: url(#linear-gradient-119);\n      }\n\n      .cls-113 {\n        fill: url(#linear-gradient-276);\n      }\n\n      .cls-114 {\n        fill: url(#linear-gradient-272);\n      }\n\n      .cls-115 {\n        fill: url(#linear-gradient-278);\n      }\n\n      .cls-116 {\n        fill: url(#linear-gradient-279);\n      }\n\n      .cls-117 {\n        fill: url(#linear-gradient-277);\n      }\n\n      .cls-118 {\n        fill: url(#linear-gradient-308);\n      }\n\n      .cls-119 {\n        fill: url(#linear-gradient-266);\n      }\n\n      .cls-120 {\n        fill: url(#linear-gradient-267);\n      }\n\n      .cls-121 {\n        fill: url(#linear-gradient-268);\n      }\n\n      .cls-122 {\n        fill: url(#linear-gradient-269);\n      }\n\n      .cls-123 {\n        fill: url(#linear-gradient-262);\n      }\n\n      .cls-124 {\n        fill: url(#linear-gradient-265);\n      }\n\n      .cls-125 {\n        fill: url(#linear-gradient-264);\n      }\n\n      .cls-126 {\n        fill: url(#linear-gradient-263);\n      }\n\n      .cls-127 {\n        fill: url(#linear-gradient-260);\n      }\n\n      .cls-128 {\n        fill: url(#linear-gradient-261);\n      }\n\n      .cls-129 {\n        fill: url(#linear-gradient-245);\n      }\n\n      .cls-130 {\n        fill: url(#linear-gradient-243);\n      }\n\n      .cls-131 {\n        fill: url(#linear-gradient-244);\n      }\n\n      .cls-132 {\n        fill: url(#linear-gradient-249);\n      }\n\n      .cls-133 {\n        fill: url(#linear-gradient-248);\n      }\n\n      .cls-134 {\n        fill: url(#linear-gradient-242);\n      }\n\n      .cls-135 {\n        fill: url(#linear-gradient-247);\n      }\n\n      .cls-136 {\n        fill: url(#linear-gradient-241);\n      }\n\n      .cls-137 {\n        fill: url(#linear-gradient-240);\n      }\n\n      .cls-138 {\n        fill: url(#linear-gradient-246);\n      }\n\n      .cls-139 {\n        fill: url(#linear-gradient-273);\n      }\n\n      .cls-140 {\n        fill: url(#linear-gradient-271);\n      }\n\n      .cls-141 {\n        fill: url(#linear-gradient-270);\n      }\n\n      .cls-142 {\n        fill: url(#linear-gradient-275);\n      }\n\n      .cls-143 {\n        fill: url(#linear-gradient-274);\n      }\n\n      .cls-144 {\n        fill: url(#linear-gradient-253);\n      }\n\n      .cls-145 {\n        fill: url(#linear-gradient-380);\n      }\n\n      .cls-146 {\n        fill: url(#linear-gradient-389);\n      }\n\n      .cls-147 {\n        fill: url(#linear-gradient-384);\n      }\n\n      .cls-148 {\n        fill: url(#linear-gradient-383);\n      }\n\n      .cls-149 {\n        fill: url(#linear-gradient-381);\n      }\n\n      .cls-150 {\n        fill: url(#linear-gradient-388);\n      }\n\n      .cls-151 {\n        fill: url(#linear-gradient-382);\n      }\n\n      .cls-152 {\n        fill: url(#linear-gradient-387);\n      }\n\n      .cls-153 {\n        fill: url(#linear-gradient-385);\n      }\n\n      .cls-154 {\n        fill: url(#linear-gradient-312);\n      }\n\n      .cls-155 {\n        fill: url(#linear-gradient-315);\n      }\n\n      .cls-156 {\n        fill: url(#linear-gradient-314);\n      }\n\n      .cls-157 {\n        fill: url(#linear-gradient-316);\n      }\n\n      .cls-158 {\n        fill: url(#linear-gradient-311);\n      }\n\n      .cls-159 {\n        fill: url(#linear-gradient-310);\n      }\n\n      .cls-160 {\n        fill: url(#linear-gradient-305);\n      }\n\n      .cls-161 {\n        fill: url(#linear-gradient-300);\n      }\n\n      .cls-162 {\n        fill: url(#linear-gradient-303);\n      }\n\n      .cls-163 {\n        fill: url(#linear-gradient-306);\n      }\n\n      .cls-164 {\n        fill: url(#linear-gradient-309);\n      }\n\n      .cls-165 {\n        fill: url(#linear-gradient-304);\n      }\n\n      .cls-166 {\n        fill: url(#linear-gradient-307);\n      }\n\n      .cls-167 {\n        fill: url(#linear-gradient-301);\n      }\n\n      .cls-168 {\n        fill: url(#linear-gradient-302);\n      }\n\n      .cls-169 {\n        fill: url(#linear-gradient-339);\n      }\n\n      .cls-170 {\n        fill: url(#linear-gradient-331);\n      }\n\n      .cls-171 {\n        fill: url(#linear-gradient-322);\n      }\n\n      .cls-172 {\n        fill: url(#linear-gradient-334);\n      }\n\n      .cls-173 {\n        fill: url(#linear-gradient-321);\n      }\n\n      .cls-174 {\n        fill: url(#linear-gradient-333);\n      }\n\n      .cls-175 {\n        fill: url(#linear-gradient-337);\n      }\n\n      .cls-176 {\n        fill: url(#linear-gradient-338);\n      }\n\n      .cls-177 {\n        fill: url(#linear-gradient-335);\n      }\n\n      .cls-178 {\n        fill: url(#linear-gradient-336);\n      }\n\n      .cls-179 {\n        fill: url(#linear-gradient-327);\n      }\n\n      .cls-180 {\n        fill: url(#linear-gradient-325);\n      }\n\n      .cls-181 {\n        fill: url(#linear-gradient-328);\n      }\n\n      .cls-182 {\n        fill: url(#linear-gradient-324);\n      }\n\n      .cls-183 {\n        fill: url(#linear-gradient-326);\n      }\n\n      .cls-184 {\n        fill: url(#linear-gradient-332);\n      }\n\n      .cls-185 {\n        fill: url(#linear-gradient-320);\n      }\n\n      .cls-186 {\n        fill: url(#linear-gradient-330);\n      }\n\n      .cls-187 {\n        fill: url(#linear-gradient-323);\n      }\n\n      .cls-188 {\n        fill: url(#linear-gradient-329);\n      }\n\n      .cls-189 {\n        fill: url(#linear-gradient-255);\n      }\n\n      .cls-190 {\n        fill: url(#linear-gradient-256);\n      }\n\n      .cls-191 {\n        fill: url(#linear-gradient-254);\n      }\n\n      .cls-192 {\n        fill: url(#linear-gradient-259);\n      }\n\n      .cls-193 {\n        fill: url(#linear-gradient-258);\n      }\n\n      .cls-194 {\n        fill: url(#linear-gradient-252);\n      }\n\n      .cls-195 {\n        fill: url(#linear-gradient-251);\n      }\n\n      .cls-196 {\n        fill: url(#linear-gradient-250);\n      }\n\n      .cls-197 {\n        fill: url(#linear-gradient-257);\n      }\n\n      .cls-198 {\n        fill: url(#linear-gradient-386);\n      }\n\n      .cls-199 {\n        fill: url(#linear-gradient-319);\n      }\n\n      .cls-200 {\n        fill: url(#linear-gradient-318);\n      }\n\n      .cls-201 {\n        fill: url(#linear-gradient-313);\n      }\n\n      .cls-202 {\n        fill: url(#linear-gradient-317);\n      }\n\n      .cls-203 {\n        fill: url(#linear-gradient-173);\n      }\n\n      .cls-204 {\n        fill: url(#linear-gradient-170);\n      }\n\n      .cls-205 {\n        fill: url(#linear-gradient-175);\n      }\n\n      .cls-206 {\n        fill: url(#linear-gradient-174);\n      }\n\n      .cls-207 {\n        fill: url(#linear-gradient-172);\n      }\n\n      .cls-208 {\n        fill: url(#linear-gradient-144);\n      }\n\n      .cls-209 {\n        fill: url(#linear-gradient-145);\n      }\n\n      .cls-210 {\n        fill: url(#linear-gradient-149);\n      }\n\n      .cls-211 {\n        fill: url(#linear-gradient-148);\n      }\n\n      .cls-212 {\n        fill: url(#linear-gradient-171);\n      }\n\n      .cls-213 {\n        fill: url(#linear-gradient-146);\n      }\n\n      .cls-214 {\n        fill: url(#linear-gradient-143);\n      }\n\n      .cls-215 {\n        fill: url(#linear-gradient-169);\n      }\n\n      .cls-216 {\n        fill: url(#linear-gradient-140);\n      }\n\n      .cls-217 {\n        fill: url(#linear-gradient-141);\n      }\n\n      .cls-218 {\n        fill: url(#linear-gradient-147);\n      }\n\n      .cls-219 {\n        fill: url(#linear-gradient-166);\n      }\n\n      .cls-220 {\n        fill: url(#linear-gradient-142);\n      }\n\n      .cls-221 {\n        fill: url(#linear-gradient-168);\n      }\n\n      .cls-222 {\n        fill: url(#linear-gradient-164);\n      }\n\n      .cls-223 {\n        fill: url(#linear-gradient-161);\n      }\n\n      .cls-224 {\n        fill: url(#linear-gradient-163);\n      }\n\n      .cls-225 {\n        fill: url(#linear-gradient-158);\n      }\n\n      .cls-226 {\n        fill: url(#linear-gradient-160);\n      }\n\n      .cls-227 {\n        fill: url(#linear-gradient-159);\n      }\n\n      .cls-228 {\n        fill: url(#linear-gradient-167);\n      }\n\n      .cls-229 {\n        fill: url(#linear-gradient-162);\n      }\n\n      .cls-230 {\n        fill: url(#linear-gradient-165);\n      }\n\n      .cls-231 {\n        fill: url(#linear-gradient-154);\n      }\n\n      .cls-232 {\n        fill: url(#linear-gradient-152);\n      }\n\n      .cls-233 {\n        fill: url(#linear-gradient-157);\n      }\n\n      .cls-234 {\n        fill: url(#linear-gradient-155);\n      }\n\n      .cls-235 {\n        fill: url(#linear-gradient-151);\n      }\n\n      .cls-236 {\n        fill: url(#linear-gradient-153);\n      }\n\n      .cls-237 {\n        fill: url(#linear-gradient-150);\n      }\n\n      .cls-238 {\n        fill: url(#linear-gradient-156);\n      }\n\n      .cls-239 {\n        fill: url(#linear-gradient-239);\n      }\n\n      .cls-240 {\n        fill: url(#linear-gradient-233);\n      }\n\n      .cls-241 {\n        fill: url(#linear-gradient-234);\n      }\n\n      .cls-242 {\n        fill: url(#linear-gradient-209);\n      }\n\n      .cls-243 {\n        fill: url(#linear-gradient-236);\n      }\n\n      .cls-244 {\n        fill: url(#linear-gradient-230);\n      }\n\n      .cls-245 {\n        fill: url(#linear-gradient-235);\n      }\n\n      .cls-246 {\n        fill: url(#linear-gradient-219);\n      }\n\n      .cls-247 {\n        fill: url(#linear-gradient-290);\n      }\n\n      .cls-248 {\n        fill: url(#linear-gradient-289);\n      }\n\n      .cls-249 {\n        fill: url(#linear-gradient-288);\n      }\n\n      .cls-250 {\n        fill: url(#linear-gradient-285);\n      }\n\n      .cls-251 {\n        fill: url(#linear-gradient-286);\n      }\n\n      .cls-252 {\n        fill: url(#linear-gradient-287);\n      }\n\n      .cls-253 {\n        fill: url(#linear-gradient-280);\n      }\n\n      .cls-254 {\n        fill: url(#linear-gradient-282);\n      }\n\n      .cls-255 {\n        fill: url(#linear-gradient-284);\n      }\n\n      .cls-256 {\n        fill: url(#linear-gradient-281);\n      }\n\n      .cls-257 {\n        fill: url(#linear-gradient-283);\n      }\n\n      .cls-258 {\n        fill: url(#linear-gradient-213);\n      }\n\n      .cls-259 {\n        fill: url(#linear-gradient-211);\n      }\n\n      .cls-260 {\n        fill: url(#linear-gradient-214);\n      }\n\n      .cls-261 {\n        fill: url(#linear-gradient-237);\n      }\n\n      .cls-262 {\n        fill: url(#linear-gradient-238);\n      }\n\n      .cls-263 {\n        fill: url(#linear-gradient-299);\n      }\n\n      .cls-264 {\n        fill: url(#linear-gradient-231);\n      }\n\n      .cls-265 {\n        fill: url(#linear-gradient-232);\n      }\n\n      .cls-266 {\n        fill: url(#linear-gradient-292);\n      }\n\n      .cls-267 {\n        fill: url(#linear-gradient-293);\n      }\n\n      .cls-268 {\n        fill: url(#linear-gradient-294);\n      }\n\n      .cls-269 {\n        fill: url(#linear-gradient-291);\n      }\n\n      .cls-270 {\n        fill: url(#linear-gradient-296);\n      }\n\n      .cls-271 {\n        fill: url(#linear-gradient-295);\n      }\n\n      .cls-272 {\n        fill: url(#linear-gradient-298);\n      }\n\n      .cls-273 {\n        fill: url(#linear-gradient-297);\n      }\n\n      .cls-274 {\n        fill: url(#linear-gradient-215);\n      }\n\n      .cls-275 {\n        fill: url(#linear-gradient-217);\n      }\n\n      .cls-276 {\n        fill: url(#linear-gradient-212);\n      }\n\n      .cls-277 {\n        fill: url(#linear-gradient-218);\n      }\n\n      .cls-278 {\n        fill: url(#linear-gradient-208);\n      }\n\n      .cls-279 {\n        fill: url(#linear-gradient-207);\n      }\n\n      .cls-280 {\n        fill: url(#linear-gradient-205);\n      }\n\n      .cls-281 {\n        fill: url(#linear-gradient-201);\n      }\n\n      .cls-282 {\n        fill: url(#linear-gradient-203);\n      }\n\n      .cls-283 {\n        fill: url(#linear-gradient-204);\n      }\n\n      .cls-284 {\n        fill: url(#linear-gradient-206);\n      }\n\n      .cls-285 {\n        fill: url(#linear-gradient-200);\n      }\n\n      .cls-286 {\n        fill: url(#linear-gradient-202);\n      }\n\n      .cls-287 {\n        fill: url(#linear-gradient-210);\n      }\n\n      .cls-288 {\n        fill: url(#linear-gradient-216);\n      }\n\n      .cls-289 {\n        fill: url(#linear-gradient-228);\n      }\n\n      .cls-290 {\n        fill: url(#linear-gradient-229);\n      }\n\n      .cls-291 {\n        fill: url(#linear-gradient-223);\n      }\n\n      .cls-292 {\n        fill: url(#linear-gradient-227);\n      }\n\n      .cls-293 {\n        fill: url(#linear-gradient-225);\n      }\n\n      .cls-294 {\n        fill: url(#linear-gradient-222);\n      }\n\n      .cls-295 {\n        fill: url(#linear-gradient-224);\n      }\n\n      .cls-296 {\n        fill: url(#linear-gradient-226);\n      }\n\n      .cls-297 {\n        fill: url(#linear-gradient-220);\n      }\n\n      .cls-298 {\n        fill: url(#linear-gradient-221);\n      }\n\n      .cls-398 {\n        opacity: .06;\n      }\n\n      .cls-299 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-300 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-301 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-302 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-303 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-304 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-305 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-306 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-307 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-308 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-309 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-310 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-311 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-312 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-313 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-314 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-315 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-316 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-317 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-318 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-319 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-320 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-321 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-322 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-323 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-324 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-325 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-326 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-327 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-328 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-329 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-330 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-331 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-332 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-333 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-334 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-335 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-336 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-337 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-338 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-339 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-340 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-341 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-342 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-343 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-344 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-345 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-346 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-347 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-348 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-349 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-350 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-351 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-352 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-353 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-354 {\n        fill: url(#linear-gradient-79);\n      }\n\n      .cls-355 {\n        fill: url(#linear-gradient-78);\n      }\n\n      .cls-356 {\n        fill: url(#linear-gradient-77);\n      }\n\n      .cls-357 {\n        fill: url(#linear-gradient-75);\n      }\n\n      .cls-358 {\n        fill: url(#linear-gradient-76);\n      }\n\n      .cls-359 {\n        fill: url(#linear-gradient-74);\n      }\n\n      .cls-360 {\n        fill: url(#linear-gradient-67);\n      }\n\n      .cls-361 {\n        fill: url(#linear-gradient-68);\n      }\n\n      .cls-362 {\n        fill: url(#linear-gradient-66);\n      }\n\n      .cls-363 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-364 {\n        fill: url(#linear-gradient-69);\n      }\n\n      .cls-365 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-366 {\n        fill: url(#linear-gradient-71);\n      }\n\n      .cls-367 {\n        fill: url(#linear-gradient-72);\n      }\n\n      .cls-368 {\n        fill: url(#linear-gradient-70);\n      }\n\n      .cls-369 {\n        fill: url(#linear-gradient-73);\n      }\n\n      .cls-370 {\n        fill: url(#linear-gradient-84);\n      }\n\n      .cls-371 {\n        fill: url(#linear-gradient-85);\n      }\n\n      .cls-372 {\n        fill: url(#linear-gradient-82);\n      }\n\n      .cls-373 {\n        fill: url(#linear-gradient-83);\n      }\n\n      .cls-374 {\n        fill: url(#linear-gradient-89);\n      }\n\n      .cls-375 {\n        fill: url(#linear-gradient-88);\n      }\n\n      .cls-376 {\n        fill: url(#linear-gradient-86);\n      }\n\n      .cls-377 {\n        fill: url(#linear-gradient-87);\n      }\n\n      .cls-378 {\n        fill: url(#linear-gradient-80);\n      }\n\n      .cls-379 {\n        fill: url(#linear-gradient-81);\n      }\n\n      .cls-380 {\n        fill: url(#linear-gradient-98);\n      }\n\n      .cls-381 {\n        fill: url(#linear-gradient-91);\n      }\n\n      .cls-382 {\n        fill: url(#linear-gradient-92);\n      }\n\n      .cls-383 {\n        fill: url(#linear-gradient-93);\n      }\n\n      .cls-384 {\n        fill: url(#linear-gradient-90);\n      }\n\n      .cls-385 {\n        fill: url(#linear-gradient-96);\n      }\n\n      .cls-386 {\n        fill: url(#linear-gradient-97);\n      }\n\n      .cls-387 {\n        fill: url(#linear-gradient-94);\n      }\n\n      .cls-388 {\n        fill: url(#linear-gradient-95);\n      }\n\n      .cls-389 {\n        fill: url(#linear-gradient-99);\n      }\n\n      .cls-390 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-391 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-392 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-393 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-394 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-395 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-396 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-397 {\n        fill: url(#linear-gradient-6);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -25.03,
    y1: 774.19,
    x2: 391.99,
    y2: 774.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2828f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05f59b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 385.88,
    y2: 385.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 453.07,
    y2: 453.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 427.41,
    y2: 427.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 400.56,
    y2: 400.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 320.02,
    y2: 320.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 666.8,
    y2: 666.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 732.66,
    y2: 732.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 747.34,
    y2: 747.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 758.32,
    y2: 758.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 172.15,
    y2: 172.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: 518.93,
    y2: 518.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: 438.37,
    y2: 438.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 799.83,
    y2: 799.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 542.74,
    y2: 542.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    y1: 106.29,
    y2: 106.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 91.6,
    y2: 91.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: 80.63,
    y2: 80.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 64.77,
    y2: 64.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: 39.11,
    y2: 39.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 2.36,
    y2: 2.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    y1: 19.84,
    y2: 19.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 496.12,
    y2: 496.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 53.78,
    y2: 53.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 125.53,
    y2: 125.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 91.61,
    y2: 91.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 366.62,
    y2: 366.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 689.59,
    y2: 689.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 774.17,
    y2: 774.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 732.64,
    y2: 732.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 799.83,
    y2: 799.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 785.15,
    y2: 785.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    y1: 799.83,
    y2: 799.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    y1: 758.3,
    y2: 758.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    y1: 642.99,
    y2: 642.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    y1: 438.37,
    y2: 438.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    y1: 472.31,
    y2: 472.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    y1: 400.56,
    y2: 400.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    y1: 713.4,
    y2: 713.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    y1: 666.8,
    y2: 666.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    y1: 561.98,
    y2: 561.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    y1: 472.31,
    y2: 472.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    y1: 623.73,
    y2: 623.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    y1: 149.34,
    y2: 149.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    y1: 106.27,
    y2: 106.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    y1: 296.22,
    y2: 296.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    y1: 39.11,
    y2: 39.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    y1: 2.36,
    y2: 2.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    y1: 576.65,
    y2: 576.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    y1: 366.62,
    y2: 366.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    y1: 609.06,
    y2: 609.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    y1: 342.82,
    y2: 342.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    y1: 19.84,
    y2: 19.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    y1: 215.2,
    y2: 215.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    y1: 320.02,
    y2: 320.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    y1: 276.95,
    y2: 276.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    y1: 125.53,
    y2: 125.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    y1: 427.39,
    y2: 427.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    y1: 80.63,
    y2: 80.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    y1: 106.27,
    y2: 106.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    y1: 149.34,
    y2: 149.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    y1: 53.78,
    y2: 53.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    y1: 64.75,
    y2: 64.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    y1: 39.11,
    y2: 39.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    y1: 385.88,
    y2: 385.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    y1: 411.52,
    y2: 411.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    y1: 453.05,
    y2: 453.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    y1: 296.22,
    y2: 296.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    y1: 342.82,
    y2: 342.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    y1: 195.96,
    y2: 195.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    y1: 642.99,
    y2: 642.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    y1: 799.83,
    y2: 799.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    y1: 689.59,
    y2: 689.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    y1: 732.64,
    y2: 732.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    y1: 385.88,
    y2: 385.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    y1: 453.05,
    y2: 453.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    y1: 496.12,
    y2: 496.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    y1: 785.15,
    y2: 785.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    y1: 713.4,
    y2: 713.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    y1: 747.34,
    y2: 747.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    y1: 411.54,
    y2: 411.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    y1: 53.78,
    y2: 53.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    y1: 39.11,
    y2: 39.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    y1: 518.91,
    y2: 518.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    y1: 427.39,
    y2: 427.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    y1: 385.88,
    y2: 385.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    y1: 411.52,
    y2: 411.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    y1: 438.37,
    y2: 438.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    y1: 453.05,
    y2: 453.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    y1: 400.56,
    y2: 400.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    y1: 106.27,
    y2: 106.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    y1: 80.63,
    y2: 80.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    y1: 19.84,
    y2: 19.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    y1: 320,
    y2: 320,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    y1: 172.15,
    y2: 172.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    y1: 64.75,
    y2: 64.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    y1: 91.6,
    y2: 91.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    y1: 713.4,
    y2: 713.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    y1: 472.31,
    y2: 472.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    y1: 125.53,
    y2: 125.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    y1: 366.62,
    y2: 366.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    y1: 666.78,
    y2: 666.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    y1: 747.34,
    y2: 747.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    y1: 758.3,
    y2: 758.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    y1: 732.64,
    y2: 732.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    y1: 785.15,
    y2: 785.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    y1: 774.17,
    y2: 774.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    y1: 799.83,
    y2: 799.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    y1: 611.77,
    y2: 611.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    y1: 298.91,
    y2: 298.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    y1: 732.64,
    y2: 732.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    y1: 3.72,
    y2: 3.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    y1: 103.57,
    y2: 103.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    y1: 576.65,
    y2: 576.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    y1: 41.8,
    y2: 41.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    y1: 345.53,
    y2: 345.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    y1: 735.36,
    y2: 735.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    y1: 797.11,
    y2: 797.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    y1: 692.31,
    y2: 692.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    y1: 450.33,
    y2: 450.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    y1: 493.4,
    y2: 493.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    y1: 645.69,
    y2: 645.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    y1: 122.82,
    y2: 122.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    y1: 369.34,
    y2: 369.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    y1: 469.6,
    y2: 469.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    y1: 322.72,
    y2: 322.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    y1: 212.49,
    y2: 212.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    y1: 279.67,
    y2: 279.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    y1: 716.11,
    y2: 716.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    y1: 559.26,
    y2: 559.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    y1: 669.5,
    y2: 669.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    y1: 626.45,
    y2: 626.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    y1: 41.8,
    y2: 41.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    y1: 3.72,
    y2: 3.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    y1: 146.62,
    y2: 146.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    y1: 103.57,
    y2: 103.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    y1: 229.88,
    y2: 229.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    y1: 388.58,
    y2: 388.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    y1: 493.4,
    y2: 493.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    y1: 450.33,
    y2: 450.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    y1: 262.28,
    y2: 262.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    y1: 345.53,
    y2: 345.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    y1: 716.11,
    y2: 716.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    y1: 403.27,
    y2: 403.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    y1: 22.56,
    y2: 22.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    y1: 56.5,
    y2: 56.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    y1: 435.68,
    y2: 435.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    y1: 88.9,
    y2: 88.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    y1: 122.82,
    y2: 122.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    y1: 782.45,
    y2: 782.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    y1: 750.05,
    y2: 750.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    y1: 369.34,
    y2: 369.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    y1: 469.6,
    y2: 469.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    y1: 388.58,
    y2: 388.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    y1: 692.31,
    y2: 692.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    y1: 22.56,
    y2: 22.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    y1: 369.34,
    y2: 369.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    y1: 322.72,
    x2: 391.99,
    y2: 322.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    y1: 122.82,
    y2: 122.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    y1: 469.6,
    y2: 469.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    y1: 279.67,
    y2: 279.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    y1: 212.49,
    y2: 212.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    y1: 626.45,
    y2: 626.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    y1: 3.72,
    y2: 3.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    y1: 573.94,
    y2: 573.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    y1: 345.53,
    y2: 345.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    y1: 493.4,
    y2: 493.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    y1: 264.99,
    y2: 264.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    y1: 227.16,
    y2: 227.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    y1: 146.62,
    y2: 146.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    y1: 41.8,
    y2: 41.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    y1: 493.4,
    y2: 493.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    y1: 735.36,
    y2: 735.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    y1: 692.31,
    y2: 692.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    y1: 345.53,
    y2: 345.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    y1: 227.16,
    y2: 227.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    y1: 264.99,
    y2: 264.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    y1: 797.11,
    y2: 797.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    y1: 559.26,
    y2: 559.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    y1: 611.77,
    y2: 611.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    y1: 573.94,
    y2: 573.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    y1: 22.56,
    y2: 22.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    y1: 669.5,
    x2: 391.99,
    y2: 669.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    y1: 103.57,
    y2: 103.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    y1: 716.11,
    y2: 716.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    y1: 146.62,
    y2: 146.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    y1: 3.72,
    y2: 3.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    y1: 388.58,
    y2: 388.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    y1: 450.33,
    y2: 450.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    y1: 146.62,
    y2: 146.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    y1: 88.9,
    y2: 88.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    y1: 77.91,
    y2: 77.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    y1: 67.48,
    y2: 67.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    y1: 19.84,
    y2: 19.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    y1: 56.5,
    y2: 56.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    y1: 125.53,
    y2: 125.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    y1: 414.24,
    y2: 414.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    y1: 713.4,
    y2: 713.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    y1: 472.31,
    y2: 472.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    y1: 424.69,
    y2: 424.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    y1: 403.27,
    y2: 403.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    y1: 435.68,
    y2: 435.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    y1: 366.62,
    y2: 366.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    y1: 149.34,
    y2: 149.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    y1: 342.82,
    y2: 342.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    y1: 450.33,
    y2: 450.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    y1: 388.58,
    y2: 388.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    y1: 103.57,
    y2: 103.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    y1: 41.8,
    y2: 41.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    y1: 797.11,
    y2: 797.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    y1: 496.12,
    y2: 496.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    y1: 689.59,
    y2: 689.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    y1: 735.36,
    y2: 735.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    y1: 342.82,
    x2: 391.99,
    y2: 342.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    y1: 385.88,
    y2: 385.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    y1: 453.05,
    y2: 453.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    y1: 149.34,
    y2: 149.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    y1: 262.28,
    y2: 262.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    y1: 609.06,
    y2: 609.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    y1: 496.12,
    y2: 496.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    y1: 229.88,
    y2: 229.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    y1: 2.36,
    y2: 2.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    y1: 771.47,
    y2: 771.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    y1: 750.05,
    y2: 750.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    y1: 782.45,
    y2: 782.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    y1: 761.02,
    y2: 761.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    y1: 106.27,
    y2: 106.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    y1: 39.11,
    y2: 39.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    y1: 2.36,
    x2: 391.99,
    y2: 2.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    y1: 689.59,
    x2: 391.99,
    y2: 689.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    y1: 771.47,
    y2: 771.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    y1: 761.02,
    y2: 761.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    y1: 716.11,
    y2: 716.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    y1: 623.73,
    y2: 623.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    y1: 561.98,
    y2: 561.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    y1: 669.5,
    y2: 669.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    y1: 67.48,
    y2: 67.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    y1: 77.91,
    y2: 77.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    y1: 22.56,
    y2: 22.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    y1: 797.11,
    y2: 797.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    y1: 735.36,
    y2: 735.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    y1: 692.31,
    y2: 692.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    y1: 276.95,
    y2: 276.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    y1: 322.72,
    y2: 322.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    y1: 215.2,
    y2: 215.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    y1: 469.6,
    y2: 469.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    y1: 750.05,
    y2: 750.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    y1: 435.68,
    y2: 435.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    y1: 403.27,
    y2: 403.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    y1: 642.99,
    y2: 642.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    y1: 782.45,
    y2: 782.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    y1: 122.82,
    y2: 122.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    y1: 609.06,
    y2: 609.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    y1: 88.9,
    y2: 88.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    y1: 195.96,
    y2: 195.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    y1: 56.5,
    y2: 56.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    y1: 251.29,
    y2: 251.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    y1: 369.34,
    y2: 369.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    y1: 240.86,
    y2: 240.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    y1: 229.88,
    y2: 229.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    y1: 414.24,
    y2: 414.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    y1: 424.69,
    y2: 424.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    y1: 262.28,
    y2: 262.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    y1: 598.07,
    y2: 598.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    y1: 587.64,
    y2: 587.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    y1: 576.65,
    y2: 576.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    y1: 296.22,
    y2: 296.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    y1: 542.74,
    y2: 542.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    y1: 865.71,
    y2: 865.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    y1: 518.93,
    y2: 518.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    y1: 172.15,
    y2: 172.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    y1: 908.76,
    y2: 908.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    y1: 819.07,
    y2: 819.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    y1: 542.74,
    y2: 542.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    y1: 889.51,
    y2: 889.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    y1: 642.99,
    y2: 642.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    y1: 561.98,
    y2: 561.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    y1: 195.96,
    y2: 195.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    y1: 923.43,
    y2: 923.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    y1: 842.88,
    y2: 842.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    y1: 215.2,
    y2: 215.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    y1: 172.15,
    y2: 172.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    y1: 542.74,
    y2: 542.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    y1: 320.02,
    y2: 320.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    y1: 518.93,
    y2: 518.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    y1: 276.95,
    y2: 276.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    y1: 842.88,
    y2: 842.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    y1: 889.51,
    y2: 889.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    y1: 296.22,
    y2: 296.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    y1: 923.43,
    y2: 923.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    y1: 842.88,
    y2: 842.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    y1: 172.15,
    y2: 172.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    y1: 862.99,
    y2: 862.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    y1: 908.76,
    y2: 908.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    y1: 516.21,
    y2: 516.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    y1: 934.4,
    y2: 934.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    y1: 816.37,
    y2: 816.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    y1: 889.51,
    y2: 889.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    y1: 215.2,
    y2: 215.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    y1: 666.8,
    y2: 666.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    y1: 195.96,
    y2: 195.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    y1: 819.07,
    y2: 819.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-303",
    y1: 908.76,
    y2: 908.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-304",
    y1: 865.71,
    y2: 865.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-305",
    y1: 320.02,
    y2: 320.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-306",
    y1: 276.95,
    y2: 276.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-307",
    y1: 561.98,
    y2: 561.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-308",
    y1: 518.93,
    y2: 518.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-309",
    y1: 623.73,
    y2: 623.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-310",
    y1: 623.73,
    y2: 623.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-311",
    y1: 865.71,
    y2: 865.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-312",
    y1: 819.07,
    y2: 819.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-313",
    y1: 19.86,
    y2: 19.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-314",
    y1: 366.64,
    y2: 366.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-315",
    y1: 666.8,
    y2: 666.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-316",
    y1: 908.76,
    y2: 908.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-317",
    y1: 865.71,
    y2: 865.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-318",
    y1: 472.31,
    y2: 472.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-319",
    y1: 842.88,
    y2: 842.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-320",
    y1: 889.51,
    y2: 889.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-321",
    y1: 819.07,
    y2: 819.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-322",
    y1: 125.53,
    y2: 125.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-323",
    y1: 713.42,
    y2: 713.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-324",
    y1: 865.69,
    y2: 865.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-325",
    y1: 819.09,
    y2: 819.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-326",
    y1: 169.44,
    y2: 169.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-327",
    y1: 645.69,
    y2: 645.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-328",
    y1: 600.79,
    y2: 600.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-329",
    y1: 584.92,
    y2: 584.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-330",
    y1: 298.91,
    y2: 298.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-331",
    y1: 540.02,
    y2: 540.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-332",
    y1: 886.8,
    y2: 886.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-333",
    y1: 645.69,
    y2: 645.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-334",
    y1: 254.01,
    y2: 254.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-335",
    y1: 238.14,
    y2: 238.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-336",
    y1: 931.7,
    y2: 931.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-337",
    y1: 193.24,
    y2: 193.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-338",
    y1: 193.24,
    y2: 193.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-339",
    y1: 906.04,
    y2: 906.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-340",
    y1: 816.37,
    y2: 816.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-341",
    y1: 298.91,
    y2: 298.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-342",
    y1: 169.44,
    y2: 169.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-343",
    y1: 840.18,
    y2: 840.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-344",
    y1: 920.72,
    y2: 920.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-345",
    y1: 516.21,
    y2: 516.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-346",
    y1: 862.99,
    y2: 862.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-347",
    y1: 254.01,
    y2: 254.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-348",
    y1: 584.92,
    y2: 584.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-349",
    y1: 540.02,
    y2: 540.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-350",
    y1: 238.14,
    y2: 238.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-351",
    y1: 600.79,
    y2: 600.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-352",
    y1: 931.7,
    y2: 931.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-353",
    y1: 279.67,
    y2: 279.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-354",
    y1: 212.49,
    y2: 212.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-355",
    y1: 906.04,
    y2: 906.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-356",
    y1: 559.26,
    y2: 559.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-357",
    y1: 626.45,
    y2: 626.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-358",
    y1: 920.72,
    y2: 920.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-359",
    y1: 227.16,
    y2: 227.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-360",
    y1: 264.99,
    y2: 264.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-361",
    y1: 573.94,
    y2: 573.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-362",
    y1: 611.77,
    y2: 611.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-363",
    y1: 626.45,
    y2: 626.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-364",
    y1: 906.04,
    y2: 906.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-365",
    y1: 816.37,
    y2: 816.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-366",
    y1: 516.21,
    y2: 516.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-367",
    y1: 862.99,
    y2: 862.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-368",
    y1: 559.26,
    y2: 559.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-369",
    y1: 669.5,
    y2: 669.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-370",
    y1: 934.4,
    y2: 934.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-371",
    y1: 886.8,
    y2: 886.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-372",
    y1: 598.07,
    y2: 598.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-373",
    y1: 840.18,
    y2: 840.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-374",
    y1: 923.43,
    y2: 923.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-375",
    y1: 251.29,
    y2: 251.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-376",
    y1: 240.86,
    y2: 240.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-377",
    y1: 193.24,
    y2: 193.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-378",
    y1: 587.64,
    y2: 587.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-379",
    y1: 298.91,
    y2: 298.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-380",
    y1: 816.37,
    y2: 816.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-381",
    y1: 906.04,
    y2: 906.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-382",
    y1: 862.99,
    y2: 862.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-383",
    y1: 193.24,
    y2: 193.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-384",
    y1: 540.02,
    y2: 540.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-385",
    y1: 886.8,
    y2: 886.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-386",
    y1: 322.72,
    y2: 322.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-387",
    y1: 840.18,
    y2: 840.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-388",
    y1: 886.8,
    y2: 886.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-389",
    y1: 516.21,
    y2: 516.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-390",
    y1: 169.44,
    y2: 169.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-391",
    y1: 645.69,
    y2: 645.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-392",
    y1: 920.72,
    y2: 920.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-393",
    y1: 169.44,
    y2: 169.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-394",
    y1: 212.49,
    y2: 212.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-395",
    y1: 279.67,
    y2: 279.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-396",
    y1: 840.18,
    y2: 840.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-397",
    y1: 540.02,
    y2: 540.02,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-398"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-299",
    x: 22.33,
    y: 771.57,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M31.73,380.67h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M23.7,458.28h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-390",
    x: 22.33,
    y: 424.79,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M32.2,397.62v5.88c0,.3.24.54.54.54h5.71c.14,0,.26-.06.36-.14.1.08.22.14.36.14h5.71c.3,0,.54-.24.54-.54v-5.88c0-.3-.24-.54-.54-.54h-5.71c-.14,0-.26.06-.36.14-.1-.08-.22-.14-.36-.14h-5.71c-.3,0-.54.24-.54.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M22.67,327.64c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M22.67,674.42c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "M31.73,727.45h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M32.2,744.4v5.88c0,.3.24.54.54.54h5.71c.14,0,.26-.06.36-.14.1.08.22.14.36.14h5.71c.3,0,.54-.24.54-.54v-5.88c0-.3-.24-.54-.54-.54h-5.71c-.14,0-.26.06-.36.14-.1-.08-.22-.14-.36-.14h-5.71c-.3,0-.54.24-.54.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-316",
    x: 22.33,
    y: 755.71,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M22.67,164.53v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M22.67,511.31v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M38.82,441.71c.1.09.22.15.37.15h5.71c.3,0,.54-.24.54-.54v-5.88c0-.3-.24-.54-.54-.54h-5.71c-.14,0-.27.06-.37.15-.1-.09-.22-.15-.37-.15h-5.71c-.3,0-.54.24-.54.54v5.88c0,.3.24.54.54.54h5.71c.14,0,.27-.06.37-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M131.39,794.61c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M48.79,549.68h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M23.7,111.5h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M38.84,94.94c.1.08.22.14.35.14h5.71c.3,0,.54-.24.54-.54v-5.88c0-.3-.24-.54-.54-.54h-5.71c-.15,0-.28.06-.38.16-.1-.08-.22-.14-.35-.14h-5.71c-.3,0-.54.24-.54.54v5.88c0,.3.24.54.54.54h5.71c.15,0,.28-.06.38-.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-323",
    x: 22.33,
    y: 78.02,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-319",
    x: 22.33,
    y: 62.15,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M31.73,33.89h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M41.96,0v3.66c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07V0h-16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M75.37,12.89h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M41.96,488.49v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M75.28,50.3h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M76.44,131.41v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M75.28,88.13h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M75.37,359.67h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M58.93,697.22v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M50.72,771.55h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M55.54,728.5c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M46.42,805.04h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M38.82,788.49c.1.09.22.15.37.15h5.71c.3,0,.54-.24.54-.54v-5.88c0-.3-.24-.54-.54-.54h-5.71c-.14,0-.27.06-.37.15-.1-.09-.22-.15-.37-.15h-5.71c-.3,0-.54.24-.54.54v5.88c0,.3.24.54.54.54h5.71c.14,0,.27-.06.37-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M23.7,805.04h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M50.72,755.69h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M61.29,648.88v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-306",
    x: 74.74,
    y: 434.89,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M76.44,478.19v-11.76c0-.58-.47-1.07-1.07-1.07h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.42c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M75.28,397.07h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M106.35,720.35h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M107.55,659.18v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M120.04,567.2c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M106.35,479.26h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M110.94,627.88c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M85.54,158.03h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M96.99,101.05h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M91.22,303.16h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M98.07,34.96c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M84.47,0v3.66c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07V0h-16.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-334",
    x: 127.46,
    y: 573.17,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M106.35,373.57h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-346",
    x: 127.48,
    y: 605.57,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M85.54,351.51h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M106.35,26.79h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M120.04,220.42c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M107.55,312.4v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M110.94,281.1c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M106.35,132.48h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M50.72,424.78h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-340",
    x: 50.18,
    y: 78.02,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M45.35,110.42c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M41.96,141.72v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M32.2,50.84v5.88c0,.3.24.54.54.54h5.71c.14,0,.26-.06.36-.14.1.08.22.14.36.14h5.71c.3,0,.54-.24.54-.54v-5.88c0-.3-.24-.54-.54-.54h-5.71c-.14,0-.26.06-.36.14-.1-.08-.22-.14-.36-.14h-5.71c-.3,0-.54.24-.54.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M50.72,62.13h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M55.54,34.96c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M46.44,391.1h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M50.72,408.91h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M45.35,457.2c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M48.79,289.27c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M41.96,350.44c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M61.29,190.08c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M91.22,649.94h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M96.99,794.61h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M85.54,698.28h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M98.07,728.5c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M98.07,381.74c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M96.99,447.83h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M85.54,504.81h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M75.28,781.67h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M75.37,706.45h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M75.28,743.85h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-379",
    x: 22.33,
    y: 408.93,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M0,57.26h3.43c.3,0,.54-.24.54-.54v-5.88c0-.3-.24-.54-.54-.54H0v6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M12.48,33.89H4.44c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M13.51,511.29c0-.58-.47-1.07-1.07-1.07H0v17.38h12.44c.58,0,1.07-.47,1.07-1.07v-15.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M9.28,424.78h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M12.48,380.67H4.44c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M9.28,408.91h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M3.98,441.31v-5.88c0-.3-.24-.54-.54-.54H0v6.97h3.43c.3,0,.54-.24.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M4.44,458.26h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07H4.44c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M0,404.04h3.43c.3,0,.54-.24.54-.54v-5.88c0-.3-.24-.54-.54-.54H0v6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M4.44,111.49h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07H4.44c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-382",
    x: 8.73,
    y: 78.02,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M21.52,26.79h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M13.49,327.63v-15.25c0-.58-.47-1.07-1.07-1.07H0v17.38h12.42c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M13.51,164.53c0-.58-.47-1.07-1.07-1.07H0v17.38h12.44c.58,0,1.07-.47,1.07-1.07v-15.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M9.28,62.13h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M3.98,94.54v-5.88c0-.3-.24-.54-.54-.54H0v6.97h3.43c.3,0,.54-.24.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M21.52,720.35h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M21.52,479.26h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M21.52,132.48h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M21.52,373.57h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M13.49,674.4v-15.25c0-.58-.47-1.07-1.07-1.07H0v17.38h12.42c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M0,750.82h3.43c.3,0,.54-.24.54-.54v-5.88c0-.3-.24-.54-.54-.54H0v6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M9.28,755.69h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M12.48,727.43H4.44c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M3.98,788.09v-5.88c0-.3-.24-.54-.54-.54H0v6.97h3.43c.3,0,.54-.24.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M9.28,771.55h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M4.44,805.04h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07H4.44c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M338.04,608.29h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M258.7,305.86h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M140.5,728.5c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M251.96,0v6.38c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07V0h-16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M264.47,98.36h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M212,573.17h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M265.55,37.65c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M253.02,354.22h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M265.55,731.21c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M264.47,791.89h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M253.02,701h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M264.47,445.12h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M253.02,502.09h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M258.7,652.64h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M273.83,129.77h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M273.83,376.28h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M273.83,476.54h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M275.03,315.1v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M287.52,217.7c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M278.42,283.82c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M273.83,723.06h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M287.52,564.48c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M275.03,661.87v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M278.42,630.6c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M223.02,37.65c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M209.44,0v6.38c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07V0h-16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M210.51,155.31h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M221.93,98.36h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M212,226.39h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M223.02,384.43c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M210.51,502.09h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M221.93,445.12h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M212,258.79h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M210.51,354.22h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M242.87,709.17h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M242.76,399.79h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M242.87,15.61h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M242.76,53.01h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M242.76,432.19h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M242.76,85.41h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M231.43,129.77h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M242.76,778.97h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 242.22,
    y: 746.57,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M242.87,362.39h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M231.43,476.54h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M265.55,384.43c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M337.9,701h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M316.27,29.51h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M316.27,376.28h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M317.55,315.1v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M316.27,129.77h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M316.27,476.54h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M320.95,283.82c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M330.06,217.7c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M320.95,630.6c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M336.84,0v6.38c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07V0h-16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M338.04,570.46h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M337.9,354.22h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M337.9,502.09h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M338.04,261.51h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M338.04,223.68h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M337.9,155.31h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M307.99,37.65c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M295.46,502.09h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M307.99,731.21c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M311.38,699.93v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M311.38,353.15v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M295.5,223.68h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M295.5,261.51h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M306.91,791.89h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M330.06,564.48c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M295.5,608.29h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M295.5,570.46h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M273.83,29.51h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M317.55,661.87v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M306.91,98.36h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M316.27,723.06h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M295.46,155.31h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M294.41,0v6.38c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07V0h-16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M307.99,384.43c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M306.91,445.12h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M253.02,155.31h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M158.78,85.41h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M148.9,75.3h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M148.9,64.87h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M148.79,26.79h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M158.76,53.01h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M148.79,132.48h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 148.36,
    y: 411.63,
    width: 5.11,
    height: 5.23,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M148.79,720.35h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M148.79,479.26h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M148.9,422.08h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M158.76,399.79h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M158.78,432.19h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M148.79,373.57h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M170.43,158.03h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M170.43,351.51h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M171.92,445.12c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M181.03,384.43c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M171.92,98.36c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M181.03,37.65c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M171.92,791.89c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M170.43,504.81h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M170.43,698.28h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M181.03,731.21c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M143.9,350.44v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M140.5,381.74c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M131.39,447.83c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M127.98,158.03h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 127.48,
    y: 258.79,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M212,605.57h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M127.98,504.81h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-298",
    x: 127.46,
    y: 226.39,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M169.36,0v3.66c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07V0h-16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M148.9,768.86h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M158.76,746.57h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M158.78,778.97h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-296",
    x: 148.36,
    y: 758.41,
    width: 5.11,
    height: 5.23,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M131.39,101.05c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M140.5,34.96c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M126.93,0v3.66c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07V0h-16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M143.9,697.22v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M190.35,768.86h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 189.81,
    y: 758.41,
    width: 5.11,
    height: 5.23,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M201.5,722v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M195.45,627.88c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M196.53,567.2h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M190.15,661.87v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M190.35,64.87h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M190.35,75.3h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M201.5,28.44v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M221.93,791.89h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M223.02,731.21c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M210.51,701h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M195.45,281.1c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M190.15,315.1v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M196.53,220.42h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M201.5,475.48v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M200.22,746.57h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M200.22,432.19h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 199.68,
    y: 399.79,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M176.04,649.94h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M200.22,778.97h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M201.5,128.7v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 170.01,
    y: 605.57,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M200.22,85.41h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M175,190.08v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M200.22,53.01h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 181.57,
    y: 248.68,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M201.5,375.22v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M182.09,238.25h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M170.56,226.39h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 189.81,
    y: 411.63,
    width: 5.11,
    height: 5.23,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M190.35,422.08h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 170.01,
    y: 258.79,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 181.57,
    y: 595.46,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 181.55,
    y: 585.03,
    width: 5.11,
    height: 5.23,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M170.56,573.17h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M176.04,303.16h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M175,536.85v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M123.47,857.02h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M123.47,510.24h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M123.47,163.46h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M120.04,903.54h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M118.84,824.95v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M145.05,535.79h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M145.05,882.57h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M145.05,636.05h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M77.6,567.2c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M102.66,189.01h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 127.46,
    y: 919.95,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M142.82,851.57c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M77.6,220.42c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M81.01,163.46h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M102.66,535.79h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M81.01,311.33h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M81.01,510.24h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M68.5,281.1c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M101.44,850.5v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M102.66,882.57h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M145.05,289.27h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M170.56,919.95h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M185.26,851.57c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M165.97,163.46h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M206.07,854.3h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M204.57,903.54h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M206.07,507.52h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M182.09,931.79h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M201.5,822.26v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M187.49,882.57h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M162.58,220.42c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M165.97,658.11h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M145.05,189.01h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M161.29,824.95v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M162.58,903.54h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M165.97,857.02h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M165.97,311.33h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M153.47,281.1c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M162.58,567.2c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M165.97,510.24h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M153.47,627.88c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M68.5,627.88c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M38.57,857.02h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M34.02,824.95v-11.76c0-.58-.47-1.07-1.07-1.07h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.42c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M14.65,12.91H3.23c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M14.65,359.69H3.23c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M81.01,658.11h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M77.6,903.54h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M81.01,857.02h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M14.65,465.36H3.23c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M58.93,850.5v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M60.22,882.57h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M76.44,824.95v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M14.65,118.59H3.23c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M14.65,706.47H3.23c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M12.44,857H0v17.38h12.44c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M14.65,812.14H3.23c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M206.07,160.75h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M227.7,638.74h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M349.59,598.17h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 349.03,
    y: 582.31,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M354.97,291.96h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M354.97,533.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M354.97,879.85h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M354.97,638.74h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M349.59,251.4h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 349.03,
    y: 235.53,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M349.57,929.09h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M354.97,186.29h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M312.53,186.29h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M330.06,900.83h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M328.76,822.26v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M312.53,291.96h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M333.47,160.75h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M352.74,848.87c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M338.04,917.23h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M333.47,507.52h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M333.47,854.3h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M391.04,251.4h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M391.04,582.31h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M312.53,533.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M391.04,235.53h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M391.04,598.17h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M391.04,929.09h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M372.05,274.45h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M372.05,207.27h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M372.05,900.83h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M372.05,554.05h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M372.05,621.23h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M379.48,917.23h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M379.48,223.68h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M379.48,261.51h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M379.48,570.46h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M379.48,608.29h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M235.98,630.6c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M245.1,900.83h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M243.92,822.26v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M248.49,507.52h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M248.49,854.3h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M237.06,564.48h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M248.49,660.81h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 223.02,
    y: 931.79,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M227.7,879.85h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 223.02,
    y: 595.46,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M226.41,847.8v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 211.46,
    y: 919.95,
    width: 6.8,
    height: 6.97,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 223.02,
    y: 248.68,
    width: 5.11,
    height: 5.22,
    rx: 0.54,
    ry: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M223.56,238.25h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M227.7,186.29h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M223.56,585.03h4.03c.3,0,.54.24.54.54v4.14c0,.3-.24.54-.54.54h-4.03c-.3,0-.54-.24-.54-.54v-4.14c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M227.7,291.96h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M286.32,822.26v-11.76c0-.58-.47-1.07-1.07-1.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M287.52,900.83h-8.03c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M290.95,854.3h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M270.14,186.29h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M270.14,533.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M270.14,879.85h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M248.49,314.03h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M310.3,848.87c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M312.53,879.85h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M290.95,507.52h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.95,160.75h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M312.53,638.74h-11.42c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.42c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.5,917.23h5.71c.3,0,.54.24.54.54v5.88c0,.3-.24.54-.54.54h-5.71c-.3,0-.54-.24-.54-.54v-5.88c0-.3.24-.54.54-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.49,160.75h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07v-15.25c0-.58-.47-1.07-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M237.06,217.7h8.04c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.04c-.58,0-1.07.47-1.07,1.07v8.3c0,.58.47,1.07,1.07,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.98,283.82c0,.58.47,1.07,1.07,1.07h8.03c.58,0,1.07-.47,1.07-1.07v-8.3c0-.58-.47-1.07-1.07-1.07h-8.03c-.58,0-1.07.47-1.07,1.07v8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.92,847.8v-15.25c0-.58-.47-1.07-1.07-1.07h-14.83c-.58,0-1.07.47-1.07,1.07v15.25c0,.58.47,1.07,1.07,1.07h14.83c.58,0,1.07-.47,1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M227.7,533.07h-11.43c-.58,0-1.07.47-1.07,1.07v11.76c0,.58.47,1.07,1.07,1.07h11.43c.58,0,1.07-.47,1.07-1.07v-11.76c0-.58-.47-1.07-1.07-1.07Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternLeft);
export default __webpack_public_path__ + "static/media/patternLeft.5cc7aab6c10a5c700c17843b87b3e149.svg";
export { ForwardRef as ReactComponent };